import QrServerCodeData from "@/http/data/qr-server-code-data";
import QrServerLogEntryData from "@/http/data/qr-server-log-entry-data";
import QrServerLogFiltersData from "@/http/data/qr-server-log-filters-data";
import {QrServerLogMetaData} from "@/http/data/qr-server-log-page-data";

export enum QrServerStatus {
    Failed = "failed",
    NotImplemented = "not_implemented",
    Unauthenticated = "unauthenticated",
    Forbidden = "forbidden",
    Empty = "empty",
    Loading = "loading",
    Ready = "ready"
}

export default class QrServerState {
    codes: QrServerCodeData[] = [];
    logs: QrServerLogEntryData[] = [];
    codesStatus: QrServerStatus = QrServerStatus.Failed;
    logsStatus: QrServerStatus = QrServerStatus.Failed;
    logsMeta: QrServerLogMetaData | null = null;
    selectedLogsPage = 1;
    logFilterOptions: QrServerLogFiltersData = new QrServerLogFiltersData({
        types: [],
        codes: []
    });
    logFilters: QrServerLogFiltersData = new QrServerLogFiltersData({
        types: [],
        codes: []
    });
    lastFetchedLogFilters: QrServerLogFiltersData = new QrServerLogFiltersData({
        types: [],
        codes: []
    });
    isInitialized = false;
}
